module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-12-0fb1c2912ab20f9f2a6646c06e722c9f.jpg";